import React, { useEffect, useState } from 'react';

const SidebarIcon = ({ type, className = "", active = false }) => {
  const [accentFrom, setAccentFrom] = useState('#f97316');
  const [accentTo, setAccentTo] = useState('#fbbf24');

  useEffect(() => {
    // Get CSS variables from root
    const root = document.documentElement;
    const style = getComputedStyle(root);
    setAccentFrom(style.getPropertyValue('--accent-from').trim());
    setAccentTo(style.getPropertyValue('--accent-to').trim());
  }, []);

  const icons = {
    create: (
      <svg viewBox="0 0 24 24" fill="none" className={className}>
        <defs>
          <linearGradient id="create-grad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor={accentFrom} />
            <stop offset="100%" stopColor={accentTo} />
          </linearGradient>
        </defs>
        <path d="M12 4L14.5 9.5L20 12L14.5 14.5L12 20L9.5 14.5L4 12L9.5 9.5L12 4Z" fill="url(#create-grad)" opacity="0.8"/>
        <path d="M18 2L19 5L22 6L19 7L18 10L17 7L14 6L17 5L18 2Z" fill="url(#create-grad)"/>
      </svg>
    ),
    ideas: (
      <svg viewBox="0 0 24 24" fill="none" className={className}>
        <defs>
          <linearGradient id="ideas-grad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#fbbf24" />
            <stop offset="100%" stopColor="#f59e0b" />
          </linearGradient>
        </defs>
        <circle cx="12" cy="10" r="4" stroke="url(#ideas-grad)" strokeWidth="2" fill="none"/>
        <path d="M9 14C9 14 9 16 9 17C9 18.5 10.5 20 12 20C13.5 20 15 18.5 15 17C15 16 15 14 15 14" stroke="url(#ideas-grad)" strokeWidth="2" strokeLinecap="round"/>
        <line x1="12" y1="4" x2="12" y2="6" stroke="url(#ideas-grad)" strokeWidth="2" strokeLinecap="round"/>
        <line x1="6" y1="7" x2="7.5" y2="8.5" stroke="url(#ideas-grad)" strokeWidth="2" strokeLinecap="round"/>
        <line x1="18" y1="7" x2="16.5" y2="8.5" stroke="url(#ideas-grad)" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    ),
    aimagic: (
      <svg viewBox="0 0 24 24" fill="none" className={className}>
        <defs>
          <linearGradient id="magic-grad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#a855f7" />
            <stop offset="50%" stopColor="#f97316" />
            <stop offset="100%" stopColor="#fbbf24" />
          </linearGradient>
        </defs>
        <path d="M4 20L20 4" stroke="url(#magic-grad)" strokeWidth="2.5" strokeLinecap="round"/>
        <circle cx="20" cy="4" r="2" fill="url(#magic-grad)"/>
        <path d="M16 8L18 10" stroke="url(#magic-grad)" strokeWidth="2" strokeLinecap="round"/>
        <path d="M14 10L16 12" stroke="url(#magic-grad)" strokeWidth="2" strokeLinecap="round"/>
        <path d="M12 12L14 14" stroke="url(#magic-grad)" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    ),
    news: (
      <svg viewBox="0 0 24 24" fill="none" className={className}>
        <defs>
          <linearGradient id="news-grad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#3b82f6" />
            <stop offset="100%" stopColor="#06b6d4" />
          </linearGradient>
        </defs>
        <rect x="3" y="4" width="18" height="16" rx="2" stroke="url(#news-grad)" strokeWidth="2" fill="none"/>
        <line x1="7" y1="9" x2="17" y2="9" stroke="url(#news-grad)" strokeWidth="2" strokeLinecap="round"/>
        <line x1="7" y1="13" x2="14" y2="13" stroke="url(#news-grad)" strokeWidth="2" strokeLinecap="round"/>
        <line x1="7" y1="16" x2="11" y2="16" stroke="url(#news-grad)" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    ),
    agent: (
      <svg viewBox="0 0 24 24" fill="none" className={className}>
        <defs>
          <linearGradient id="agent-grad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#8b5cf6" />
            <stop offset="100%" stopColor="#ec4899" />
          </linearGradient>
        </defs>
        <circle cx="12" cy="8" r="4" stroke="url(#agent-grad)" strokeWidth="2" fill="none"/>
        <path d="M6 20C6 16 8.5 13 12 13C15.5 13 18 16 18 20" stroke="url(#agent-grad)" strokeWidth="2" strokeLinecap="round"/>
        <circle cx="9" cy="7" r="1" fill="url(#agent-grad)"/>
        <circle cx="15" cy="7" r="1" fill="url(#agent-grad)"/>
        <path d="M10 10C10 10 11 11 12 11C13 11 14 10 14 10" stroke="url(#agent-grad)" strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
    ),
    website: (
      <svg viewBox="0 0 24 24" fill="none" className={className}>
        <defs>
          <linearGradient id="website-grad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#10b981" />
            <stop offset="100%" stopColor="#06b6d4" />
          </linearGradient>
        </defs>
        <rect x="2" y="3" width="20" height="18" rx="2" stroke="url(#website-grad)" strokeWidth="2" fill="none"/>
        <line x1="2" y1="8" x2="22" y2="8" stroke="url(#website-grad)" strokeWidth="2"/>
        <circle cx="6" cy="6" r="1" fill="url(#website-grad)"/>
        <circle cx="9" cy="6" r="1" fill="url(#website-grad)"/>
        <circle cx="12" cy="6" r="1" fill="url(#website-grad)"/>
      </svg>
    ),
    posts: (
      <svg viewBox="0 0 24 24" fill="none" className={className}>
        <defs>
          <linearGradient id="posts-grad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#f97316" />
            <stop offset="100%" stopColor="#fbbf24" />
          </linearGradient>
        </defs>
        <path d="M9 3H6C4.89543 3 4 3.89543 4 5V19C4 20.1046 4.89543 21 6 21H18C19.1046 21 20 20.1046 20 19V5C20 3.89543 19.1046 3 18 3H15" stroke="url(#posts-grad)" strokeWidth="2"/>
        <rect x="9" y="2" width="6" height="4" rx="1" stroke="url(#posts-grad)" strokeWidth="2" fill="none"/>
        <line x1="8" y1="10" x2="16" y2="10" stroke="url(#posts-grad)" strokeWidth="2" strokeLinecap="round"/>
        <line x1="8" y1="14" x2="16" y2="14" stroke="url(#posts-grad)" strokeWidth="2" strokeLinecap="round"/>
        <line x1="8" y1="18" x2="13" y2="18" stroke="url(#posts-grad)" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    ),
    aitools: (
      <svg viewBox="0 0 24 24" fill="none" className={className}>
        <defs>
          <linearGradient id="tools-grad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#ef4444" />
            <stop offset="100%" stopColor="#f97316" />
          </linearGradient>
        </defs>
        <path d="M14.7 6.3L18 3L21 6L17.7 9.3M14.7 6.3L9.3 11.7M14.7 6.3L11.7 9.3" stroke="url(#tools-grad)" strokeWidth="2" strokeLinecap="round"/>
        <path d="M9.3 11.7L3 18L6 21L12.3 14.7M9.3 11.7L12.3 14.7" stroke="url(#tools-grad)" strokeWidth="2" strokeLinecap="round"/>
        <circle cx="12" cy="12" r="2" fill="url(#tools-grad)"/>
      </svg>
    ),
    schedule: (
      <svg viewBox="0 0 24 24" fill="none" className={className}>
        <defs>
          <linearGradient id="schedule-grad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#6366f1" />
            <stop offset="100%" stopColor="#8b5cf6" />
          </linearGradient>
        </defs>
        <rect x="3" y="4" width="18" height="18" rx="2" stroke="url(#schedule-grad)" strokeWidth="2" fill="none"/>
        <line x1="3" y1="9" x2="21" y2="9" stroke="url(#schedule-grad)" strokeWidth="2"/>
        <line x1="8" y1="2" x2="8" y2="6" stroke="url(#schedule-grad)" strokeWidth="2" strokeLinecap="round"/>
        <line x1="16" y1="2" x2="16" y2="6" stroke="url(#schedule-grad)" strokeWidth="2" strokeLinecap="round"/>
        <circle cx="8" cy="13" r="1" fill="url(#schedule-grad)"/>
        <circle cx="12" cy="13" r="1" fill="url(#schedule-grad)"/>
        <circle cx="16" cy="13" r="1" fill="url(#schedule-grad)"/>
        <circle cx="8" cy="17" r="1" fill="url(#schedule-grad)"/>
        <circle cx="12" cy="17" r="1" fill="url(#schedule-grad)"/>
      </svg>
    ),
    analytics: (
      <svg viewBox="0 0 24 24" fill="none" className={className}>
        <defs>
          <linearGradient id="analytics-grad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#06b6d4" />
            <stop offset="100%" stopColor="#3b82f6" />
          </linearGradient>
        </defs>
        <line x1="3" y1="20" x2="21" y2="20" stroke="url(#analytics-grad)" strokeWidth="2" strokeLinecap="round"/>
        <rect x="5" y="13" width="3" height="7" rx="1" fill="url(#analytics-grad)"/>
        <rect x="10.5" y="8" width="3" height="12" rx="1" fill="url(#analytics-grad)"/>
        <rect x="16" y="4" width="3" height="16" rx="1" fill="url(#analytics-grad)"/>
      </svg>
    ),
    platforms: (
      <svg viewBox="0 0 24 24" fill="none" className={className}>
        <defs>
          <linearGradient id="platforms-grad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#ec4899" />
            <stop offset="100%" stopColor="#f97316" />
          </linearGradient>
        </defs>
        <rect x="3" y="5" width="7" height="14" rx="2" stroke="url(#platforms-grad)" strokeWidth="2" fill="none"/>
        <line x1="5" y1="8" x2="8" y2="8" stroke="url(#platforms-grad)" strokeWidth="1.5" strokeLinecap="round"/>
        <circle cx="14" cy="7" r="3" stroke="url(#platforms-grad)" strokeWidth="2" fill="none"/>
        <circle cx="19" cy="7" r="3" stroke="url(#platforms-grad)" strokeWidth="2" fill="none"/>
        <circle cx="14" cy="17" r="3" stroke="url(#platforms-grad)" strokeWidth="2" fill="none"/>
        <circle cx="19" cy="17" r="3" stroke="url(#platforms-grad)" strokeWidth="2" fill="none"/>
      </svg>
    ),
    settings: (
      <svg viewBox="0 0 24 24" fill="none" className={className}>
        <defs>
          <linearGradient id="settings-grad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#6b7280" />
            <stop offset="100%" stopColor="#9ca3af" />
          </linearGradient>
        </defs>
        <circle cx="12" cy="12" r="3" stroke="url(#settings-grad)" strokeWidth="2" fill="none"/>
        <path d="M12 2L13.5 6.5L18 8L13.5 9.5L12 14L10.5 9.5L6 8L10.5 6.5L12 2Z" stroke="url(#settings-grad)" strokeWidth="1.5" fill="none"/>
        <path d="M12 22L13.5 17.5L18 16L13.5 14.5L12 10L10.5 14.5L6 16L10.5 17.5L12 22Z" stroke="url(#settings-grad)" strokeWidth="1.5" fill="none"/>
      </svg>
    ),
    admin: (
      <svg viewBox="0 0 24 24" fill="none" className={className}>
        <defs>
          <linearGradient id="admin-grad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#f97316" />
            <stop offset="100%" stopColor="#ef4444" />
          </linearGradient>
        </defs>
        <path d="M12 2L4 6V11C4 16 7 20 12 22C17 20 20 16 20 11V6L12 2Z" stroke="url(#admin-grad)" strokeWidth="2" fill="none"/>
        <path d="M9 12L11 14L15 10" stroke="url(#admin-grad)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    )
  };

  return icons[type] || <span className={className}>?</span>;
};

export default SidebarIcon;
